// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding: 0;
  margin: 0;
}

ul.horizontal {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #333333;
}
ul.horizontal > li {
  float: left;
}
ul.horizontal > li a,
ul.horizontal > li span {
  display: block;
  color: white;
  text-align: center;
  padding: 16px;
}
ul.horizontal > li aspan,
ul.horizontal > li spanspan {
  text-decoration: none;
}
ul.horizontal > li a:hover,
ul.horizontal > li span:hover {
  background-color: #111111;
}

.inner-content {
  padding-top: 50px;
}

.basic-form label {
  width: 175px;
  display: inline-block;
}

.home-brandstory-story {
  font-size: 17px;
}

.submit-extra-information-form-error span {
  display: inline-block;
  background-color: #eb3a3c;
  padding: 1rem 2rem;
  margin: 0 0 10px;
  position: relative;
  color: white;
}
.submit-extra-information-form-error span::before {
  content: "";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  border-style: solid;
  bottom: 0;
  left: 88px;
  bottom: -10px;
  border-width: 10px 12px 0 12px;
  border-color: #eb3a3c transparent transparent transparent;
}

.extra-inforamtion-confirmation-image {
  width: 60px;
  padding-right: 0.25rem;
}

@media screen and (min-width: 468px) {
  .extra-inforamtion-confirmation-image {
    width: 120px;
    padding-right: 0.65rem;
  }
}
@media screen and (min-width: 768px) {
  .extra-inforamtion-confirmation-image {
    width: unset;
    padding-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAGA;EACE,UAAA;EACA,SAAA;AAFF;;AAKA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;AAFF;AAIE;EACE,WAAA;AAFJ;AAII;;EAEE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAFN;AAIM;;EACE,qBAAA;AADR;AAIM;;EACE,yBAAA;AADR;;AAOA;EACE,iBAAA;AAJF;;AAQE;EACE,YAAA;EACA,qBAAA;AALJ;;AASA;EACE,eAAA;AANF;;AAUE;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAPJ;AAQI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,yDAAA;AANN;;AAWA;EACE,WAAA;EACA,sBAAA;AARF;;AAWA;EACE;IACE,YAAA;IACA,sBAAA;EARF;AACF;AAWA;EACE;IACE,YAAA;IACA,mBAAA;EATF;AACF","sourcesContent":["$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\nbody {\n  padding: 0;\n  margin: 0;\n}\n\nul.horizontal {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #333333;\n\n  > li {\n    float: left;\n\n    a,\n    span {\n      display: block;\n      color: white;\n      text-align: center;\n      padding: 16px;\n\n      &span {\n        text-decoration: none;\n      }\n\n      &:hover {\n        background-color: #111111;\n      }\n    }\n  }\n}\n\n.inner-content {\n  padding-top: 50px;\n}\n\n.basic-form {\n  label {\n    width: 175px;\n    display: inline-block;\n  }\n}\n\n.home-brandstory-story {\n  font-size: 17px;\n}\n\n.submit-extra-information-form-error {\n  span {\n    display: inline-block;\n    background-color: #eb3a3c;\n    padding: 1rem 2rem;\n    margin: 0 0 10px;\n    position: relative;\n    color: white;\n    &::before {\n      content: '';\n      position: absolute;\n      z-index: 1;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      bottom: 0;\n      left: calc(100px - 12px);\n      bottom: -10px;\n      border-width: 10px 12px 0 12px;\n      border-color: #eb3a3c transparent transparent transparent;\n    }\n  }\n}\n\n.extra-inforamtion-confirmation-image {\n  width: 60px;\n  padding-right: 0.25rem;\n}\n\n@media screen and (min-width: 468px) {\n  .extra-inforamtion-confirmation-image {\n    width: 120px;\n    padding-right: 0.65rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .extra-inforamtion-confirmation-image {\n    width: unset;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
